import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  Grid,
} from "@mui/material";

const DestinationSearch = ({ destinations, onSearch, onClear }) => {
  const [searchCriteria, setSearchCriteria] = useState({
    name: "",
    city: "",
    country: "",
    experience: "",
    bestSeason: "",
  });

  // Extract unique values for dropdowns
  const uniqueCountries = [...new Set(destinations.map((d) => d.country))];
  const uniqueExperiences = [
    ...new Set(destinations.flatMap((d) => d.experiences)),
  ];
  const uniqueBestSeasons = [...new Set(destinations.map((d) => d.bestSeason))];

  // Get cities based on the selected country
  const citiesForSelectedCountry = searchCriteria.country
    ? [
        ...new Set(
          destinations
            .filter((d) => d.country === searchCriteria.country)
            .map((d) => d.city)
        ),
      ]
    : [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchCriteria((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = () => {
    onSearch(searchCriteria);
  };

  const handleClear = () => {
    setSearchCriteria({
      name: "",
      city: "",
      country: "",
      experience: "",
      bestSeason: "",
    });
    onClear(); // Call the onClear prop to reset the filtered destinations
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          fullWidth
          label="Name"
          name="name"
          value={searchCriteria.name}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormControl fullWidth>
          <InputLabel>Country</InputLabel>
          <Select
            name="country"
            value={searchCriteria.country}
            onChange={handleChange}
          >
            <MenuItem value="">All</MenuItem>
            {uniqueCountries.map((country) => (
              <MenuItem key={country} value={country}>
                {country}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormControl fullWidth>
          <InputLabel>City</InputLabel>
          <Select
            name="city"
            value={searchCriteria.city}
            onChange={handleChange}
            disabled={!searchCriteria.country} // Disable if no country is selected
          >
            <MenuItem value="">All</MenuItem>
            {citiesForSelectedCountry.map((city) => (
              <MenuItem key={city} value={city}>
                {city}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormControl fullWidth>
          <InputLabel>Experience</InputLabel>
          <Select
            name="experience"
            value={searchCriteria.experience}
            onChange={handleChange}
          >
            <MenuItem value="">All</MenuItem>
            {uniqueExperiences.map((experience) => (
              <MenuItem key={experience} value={experience}>
                {experience}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <FormControl fullWidth>
          <InputLabel>Best Season</InputLabel>
          <Select
            name="bestSeason"
            value={searchCriteria.bestSeason}
            onChange={handleChange}
          >
            <MenuItem value="">All</MenuItem>
            {uniqueBestSeasons.map((season) => (
              <MenuItem key={season} value={season}>
                {season}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Button variant="contained" color="primary" onClick={handleSearch}>
          Search
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleClear}
          style={{ marginLeft: "10px" }}
        >
          Clear
        </Button>
      </Grid>
    </Grid>
  );
};

export default DestinationSearch;
